import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardProfileService {
  constructor(private httpClient: HttpClient) {}

  API_URL = environment.url_host;
  OWNER_PROFILE_DATA = `${this.API_URL}/owner_profile_data`;

  getOwnerProfileDataService(token: string, email_address: string) {
    let body = new HttpParams()
      .set('token', token)
      .set('email_address', email_address);
    let bearerToken = btoa(
      'glimpse_user_name' + ':' + 'glimpse_main_password_123',
    );
    const header = new HttpHeaders().set(
      'Authorization',
      `Basic ${bearerToken}`,
    );
    return this.httpClient
      .post(this.OWNER_PROFILE_DATA, body, { headers: header })
      .toPromise();
  }
}
